import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { segmentsQueryKeys } from "./queryKeys";

import {
  segmentFieldsResponseSchema,
  type SegmentFieldsResponse,
} from "@/features/segments/builder/schemas";
import type { SegmentField } from "@/features/segments/types";
import { instance } from "@/lib/axios/instance";

const FIELDS_STALE_TIME_MS = 20 * 60 * 1000;

export function useSegmentFields() {
  const { t } = useTranslation();

  const select = useCallback(
    (fields: SegmentFieldsResponse): SegmentField[] =>
      fields.map(({ field, labelKey, operators, defaultOperator }) => ({
        value: field,
        label: t(labelKey),
        operators,
        defaultOperator,
      })),
    [t],
  );

  return useQuery({
    queryKey: segmentsQueryKeys.fields(),
    queryFn: () =>
      instance
        .get("/api/v2/Segments/Fields")
        .then((response) => segmentFieldsResponseSchema.parse(response.data)),
    select,
    staleTime: FIELDS_STALE_TIME_MS,
    refetchOnReconnect: false,
  });
}
